import { Component, Input } from '@angular/core';

import { SafeCheckPipe } from '@boels/helpers';
import {
  BannerTypeEnum,
  CmsComponentData,
  FullWidthBannerComponentData,
} from '@boels/models';
import { BannerMarkupMediaContainerComponent } from '../banner-markup-media/banner-markup-media-container.component';
import { AsyncPipe } from '@angular/common';

@Component({
  imports: [BannerMarkupMediaContainerComponent, SafeCheckPipe, AsyncPipe],
  selector: 'boels-full-width-banner',
  templateUrl: './full-width-banner.component.html',
})
export class FullWidthBannerComponent {
  bannerType = BannerTypeEnum.FULLWIDTH;
  @Input() componentData: CmsComponentData<FullWidthBannerComponentData>;
}
